// When a user is registered by the superadmin, a link to this page is sent to their email,
// with the sent credentials the user can login and then change their password on first login
// this page has 2 input fields for the user's new password where they enter the new password and
// their password is reset. A token exists in the url of this page which is unique for each user and
// is created by the Backend, we read the token from page URL and put it in the request for
// resetting the user's password. The process of reading the token from url is handled using
// react-roter useParams hook.

import React, { useState } from "react";
import Logo from "../../Assets/Images/Logo-xsmall.svg";
import Vector from "../../Assets/Images/ResetPass.svg";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Config } from "../../Config";
import LoadingIcon from "../../Assets/Images/ButtonLoadingIcon.svg";
import PasswordInput from "../Dashboard/Components/ShareElements/TextInput/PasswordInput";

const ChangePassword = () => {
  const [IsLoading, setIsLoading] = useState(false);
  const [NewPassMessage, setNewPassMessage] = useState(
    "Please enter your new password"
  );
  const [RepeatPassMessage, setRepeatPassMessage] = useState(
    "Please fill this field."
  );
  const [ShowHints, setShowHints] = useState(false);

  //this parameter is gotten by the use of useParams hook.
  let { Token } = useParams();
  //just to make sure we always have the token
  if (!Token) {
    return null;
  }
  const checkWizardStatus = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/profile/first-wizard",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.firstWizard) {
          window.location.assign("/SetupWizard");
        } else {
          window.location.assign("/home");
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  // In this function we verify the passwords entered as new password and its repeated string,
  // in case of error, the error is displayed and in case the entries were fine the user is taken
  // to login page by calling goToLogin() function.
  const verifyEntries = (e) => {
    e.preventDefault();
    let Password = document.getElementById("new-password-input").value;
    let VerifyPassword = document.getElementById(
      "repeat-new-password-input"
    ).value;
    if (Password.length === 0) {
      // show Empty Password Error
      document.getElementById("new-password").classList.add("error-shown");
      setNewPassMessage("Please enter your new password.");
    } else if (VerifyPassword.length === 0) {
      document
        .getElementById("repeat-new-password")
        .classList.add("error-shown");
      setRepeatPassMessage("Please enter your new password again.");
    } else if (Password !== VerifyPassword) {
      // show No Match Error
      document
        .getElementById("repeat-new-password")
        .classList.add("error-shown");
      setRepeatPassMessage("The passwords do not match.");
    } else {
      // 1) validationg the password to not be the old/previous password is not done here.
      // 2) validation the length to be at least 8 characters
      if (Password.length < 8) {
        document.getElementById("policy-2").classList.remove("correct");
        document.getElementById("policy-2").classList.add("wrong");
      }
      // 3) validating containing at least one capital letter
      let CapitalLetterRegEx = /(?=.*[A-Z])/g;
      if (!Password.match(CapitalLetterRegEx)) {
        document.getElementById("policy-3").classList.remove("correct");
        document.getElementById("policy-3").classList.add("wrong");
      }
      // 4) validationg at least one digit
      let DigitRegex = /[\d]{1}/;
      if (!Password.match(DigitRegex)) {
        document.getElementById("policy-4").classList.remove("correct");
        document.getElementById("policy-4").classList.add("wrong");
      }
      // 5) validating containing at least one special character
      let SpecialCharRegEx = /^(?=.*[@#$%^!?&+=]).*$/;
      if (!Password.match(SpecialCharRegEx)) {
        document.getElementById("policy-5").classList.remove("correct");
        document.getElementById("policy-5").classList.add("wrong");
      }

      let WrongItems = 0;
      for (let i = 2; i < 6; i++) {
        if (
          document.getElementById("policy-" + i).classList.contains("wrong")
        ) {
          WrongItems++;
        }
      }
      if (WrongItems > 0) {
        document.getElementById("new-password").classList.add("error-shown");
        setNewPassMessage("");
      } else {
        requestResetPassword(Password, VerifyPassword);
      }
    }
  };
  // This function is called after validation of entries, it sends a request for password reset,
  // the Token is a URL parameter that authorizes the request and is store at component state top level
  // It also has been passed two parameters at the point it was called which stand for passwords.
  const requestResetPassword = (Password, VerifyPassword) => {
    setIsLoading(true);
    let Passwords = {
      confirm: VerifyPassword,
      password: Password,
      token: Token, //URL parameter
    };
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/change-password?token=" +
        Token,
      data: Passwords,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setIsLoading(false);
        if (Res.status === 200) {
          checkWizardStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        if (
          Err.response !== undefined &&
          Err.response.data.messages[0] ===
            "New password should be different from the old one"
        ) {
          setNewPassMessage("");
          setShowHints(true);
          document.getElementById("new-password").classList.add("error-shown");
          document.getElementById("policy-1").classList.add("wrong");
          document.getElementById("policy-1").classList.remove("correct");
        }
        setIsLoading(false);
      });
  };
  return (
    <div className="auth">
      <div className="column banner-area is-two-fifths">
        <img alt="Login to connexing" className="login-vector" src={Vector} />
      </div>
      <div className="column auth-form-area is-two-thirds">
        <div className="auth-form">
          <form className="column">
            <img className="logo" alt="login" src={Logo} />
            <p className="form-title">Change Password</p>
            <p className="info">Set a new password to login.</p>
            <PasswordInput
              Placeholder="New password"
              Id="new-password"
              HasHints
              SetHasMadeChanges={() => null}
              ErrorMessage={NewPassMessage}
              Token={Token}
              ApiPassValidation={true}
              ShowHints={ShowHints} // triggered when fail to reset password
              IsShowingHints={(e) => setShowHints(e)}
            />
            <PasswordInput
              Placeholder="Repeat new password"
              Id="repeat-new-password"
              HasHints={false}
              SetHasMadeChanges={() => null}
              ErrorMessage={RepeatPassMessage}
              Token={Token}
              ApiPassValidation={false}
            />
            <p className="wrong-cridentials-message" id="empty-password">
              Enter your password.
            </p>
            <p className="wrong-cridentials-message" id="no-match-error">
              The two passwords do not match.
            </p>
            <p className="wrong-cridentials-message" id="short-password">
              The password must be at least 8 characters long.
            </p>
            {IsLoading ? (
              <button className="reset-pass-btn disabled-btn">
                <img className="rotator" src={LoadingIcon} alt="" />
              </button>
            ) : (
              <button
                onClick={(e) => verifyEntries(e)}
                className="reset-pass-btn"
              >
                Change Password
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};
export default ChangePassword;
